import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c07c099"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metadata" }
const _hoisted_2 = { class: "title font-montserrat-bold text-2xl md:text-3xl lg:text-4xl" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "data" }
const _hoisted_5 = { class: "tags" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tags: ", -1))
const _hoisted_7 = {
  key: 0,
  class: "release-date"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Release Date:", -1))
const _hoisted_9 = {
  key: 1,
  class: "rating"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Rating:", -1))
const _hoisted_11 = { class: "developer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Developer: ", -1))
const _hoisted_13 = { class: "links" }
const _hoisted_14 = { class: "description-container" }
const _hoisted_15 = { class: "description-title font-montserrat-bold text-xl md:text-2xl lg:text-3xl" }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Link = _resolveComponent("Link")!
  const _component_LineEnding = _resolveComponent("LineEnding")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.item.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.item.tags.join(', ')), 1)
        ]),
        (_ctx.item.released)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.item.releaseDate), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.rating)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.item.rating), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.item.developer), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.item.links.steam)
          ? (_openBlock(), _createBlock(_component_Link, {
              key: 0,
              text: this.$lang.get('steam'),
              link: _ctx.item.links?.steam
            }, null, 8, ["text", "link"]))
          : _createCommentVNode("", true),
        (_ctx.item.website)
          ? (_openBlock(), _createBlock(_component_Link, {
              key: 1,
              text: this.$lang.get('website'),
              link: _ctx.item.website
            }, null, 8, ["text", "link"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.item.videos.walkthrough)
        ? (_openBlock(), _createBlock(_component_Link, {
            key: 0,
            class: "walkthrough",
            text: this.$lang.get('walkthrough'),
            link: _ctx.item.videos.walkthrough
          }, null, 8, ["text", "link"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.descriptionText), 1),
      _createElementVNode("div", {
        class: "description font-lato-regular",
        innerHTML: _ctx.item.long_description || _ctx.item.description
      }, null, 8, _hoisted_16)
    ]),
    _createVNode(_component_LineEnding)
  ]))
}